import { render, staticRenderFns } from "./new.content-blocks.page.vue?vue&type=template&id=546c8cca&"
import script from "./new.content-blocks.page.vue?vue&type=script&lang=js&"
export * from "./new.content-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports